(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/reveal-animation/assets/javascripts/reveal-animation.js') >= 0) return;  svs.modules.push('/components/components/reveal-animation/assets/javascripts/reveal-animation.js'); 
var svs = svs || {};


(function(svs) {
  'use strict';

  var log = svs.core.log.getLogger('component:reveal-animation');

  svs.components = svs.components || {};

  svs.components.RevealAnimation = function() {
    var $body = $('body');
    var $el = $body.find('.js-reveal-animation');
    var coordinates = null;
    var scrollingPos = null;
    var useAutoScroll = true;

    if ($el.length === 0) {
      $el = $('<div class="js-reveal-animation reveal-animation"></div>');
      $body.append($el);
      log.debug('Appending div to be animated');
    }

    return {
      runRevealAnimation: function(e, callback, context) {
        var $topContent = $('#top-content');
        var headerHeight = $topContent.height() + $topContent.offset().top + 12;
        var menuWidth = 0;
        var xAxel =
            e.clientX -
            (menuWidth + parseInt($('.main-content').css('margin-left'), 10));
        var yAxel = e.clientY - headerHeight + window.scrollY;
        coordinates = { x: xAxel, y: yAxel };
        scrollingPos = { x: window.scrollX, y: window.scrollY };

        $el.css(
          'top',
          $topContent.outerHeight() +
            $topContent.offset().top -
            window.scrollY +
            12
        );

        $el.on(
          'webkitTransitionEnd otransitionend msTransitionEnd transitionend',
          function() {
            $el.off('webkitTransitionEnd otransitionend msTransitionEnd transitionend');
            $el.removeClass('reveal-animation-show');
            if (useAutoScroll) {
              $body.css({ overflowY: 'auto' });
              window.scroll(0, 0);
            }
            if (callback) {
              callback.call(context);
            }
          }
        );
        useAutoScroll && $body.css({ overflowY: 'hidden' });
        $el.addClass('reveal-animation-show').css({
          '-o-transform-origin': xAxel + 'px ' + yAxel + 'px',
          '-ms-transform-origin': xAxel + 'px ' + yAxel + 'px',
          '-moz-transform-origin': xAxel + 'px ' + yAxel + 'px',
          '-webkit-transform-origin': xAxel + 'px ' + yAxel + 'px',
          'transform-origin': xAxel + 'px ' + yAxel + 'px',
          'background-color': 'white'
        });
      },
      prepareRevertRevealAnimation: function(callback, context) {
        $el.on(
          'webkitTransitionEnd otransitionend msTransitionEnd transitionend',
          function() {
            $el.off('webkitTransitionEnd otransitionend msTransitionEnd transitionend');
            if (callback) {
              callback.call(context);
            }
          }
        );
        $el.addClass('reveal-animation-revert reveal-prepare').css({
          '-o-transform-origin': coordinates.x + 'px ' + coordinates.y + 'px',
          '-ms-transform-origin': coordinates.x + 'px ' + coordinates.y + 'px',
          '-moz-transform-origin': coordinates.x + 'px ' + coordinates.y + 'px',
          '-webkit-transform-origin':
            coordinates.x + 'px ' + coordinates.y + 'px',
          'transform-origin': coordinates.x + 'px ' + coordinates.y + 'px',
          'background-color': 'white'
        });
      },
      revertRevealAnimation: function(callback, context) {
        $el.on(
          'webkitTransitionEnd otransitionend msTransitionEnd transitionend',
          function() {
            $el.off('webkitTransitionEnd otransitionend msTransitionEnd transitionend');
            $el.removeClass('reveal-prepare');
            if (callback) {
              callback.call(context);
            }
          }
        );
        if (useAutoScroll) {
          $body.css({ overflowY: 'auto' });
          window.scroll(scrollingPos.x, scrollingPos.y);
        }
        $el.removeClass('reveal-animation-revert');
        coordinates = null;
      },
      isRevertable: function() {
        return coordinates !== null;
      },
      setUseAutoScroll: function(use) {
        useAutoScroll = use;
      }
    };
  };

  svs.components.revealAnimation = new svs.components.RevealAnimation($('.main-content'));
})(svs);

 })(window);